import { render, staticRenderFns } from "./UdefLoader.vue?vue&type=template&id=5fee7242&scoped=true&"
import script from "./UdefLoader.vue?vue&type=script&lang=js&"
export * from "./UdefLoader.vue?vue&type=script&lang=js&"
import style0 from "./UdefLoader.vue?vue&type=style&index=0&id=5fee7242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fee7242",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
